import React, { Component } from 'react';
import SashiDo from 'lib/SashiDo';
import moment from 'moment';
import * as formatter from 'lib/formatter';
import history from 'dashboard/history';
import Button from 'components/Button/Button.react';
import Toolbar from 'components/Toolbar/Toolbar.react';
import Icon from 'components/Icon/Icon.react';
import settingsStyles from 'dashboard/Settings/Settings.scss';
import stylesButton from 'components/Button/Button.scss';
import PreLoader from 'components/PreLoader/PreLoader.react';
import InlineSubmitInput from 'components/InlineSubmitInput/InlineSubmitInput.react';
import Fieldset from 'components/Fieldset/Fieldset.react';
import Field from 'components/Field/Field.react';
import Label from 'components/Label/Label.react';
import { timeStampToUTC } from 'lib/DateUtils';
import Notification from 'components/Notification/Notification.react';
import AppsManager from 'lib/AppsManager';
import { isoCountries } from 'lib/Constants';
import styles from './Billing.scss';

const couponXmass = 'SASHIDOXMAS18';

export default class Billing extends Component {
  constructor(props) {
    super();

    this.subsection = 'Billing';

    this.state = {
      loading: true,
      note: null,

      appsStats: {
        stats: {},
      },
      coupons: {},
    };

    // TODO: @pivanov - move this to promiseList
    this.getCoupons().then(({ coupons }) => {
      this.setState({ coupons });
    });

    this.models = {
      name: {},
      email: {},
      address: {},
      phone: {},
      country: {},
      city: {},
      state: {},
      zip: {},
      company_name: {},
      vat_id: {},

      coupon: {},
      cc_num: {},
      expiry_date: {},
      card_name: {},
      cvv: {},
    };

    const billingAdress = props.currentCustomer.info.billing_address || { info: { billing_address: {} } };
    this.models.name.value = billingAdress.first_name ? `${billingAdress.first_name} ${billingAdress.last_name}` : '';

    this.models.email.value = billingAdress.email || props.currentUser.email;

    this.models.address.value = billingAdress.line1;

    this.models.phone.value = billingAdress.phone;

    this.models.country.value = billingAdress.country || '';

    this.models.city.value = billingAdress.city;

    this.models.state.value = billingAdress.state;

    this.models.zip.value = billingAdress.zip;

    this.models.company_name.value = billingAdress.company;

    this.models.vat_id.value = props.currentCustomer.info.vat_number || props.currentCustomer.info.cf_company_reg_no;
  }

  async componentDidMount() {
    const state = { loading: false };

    if (this.props.products && this.props.products.length > 0) {
      state.products = this.props.products;

      const promiseList = [];

      const appsStats = AppsManager.stats().then((response) => {
        return { appsStats: response.appsStats };
      });

      promiseList.push(appsStats);

      await Promise.all(promiseList).then((data) => {
        data.forEach((item) => {
          if (item.appsStats) {
            state.appsStats = item.appsStats;
          }
        });
      });
    }

    this.setState(state);
  }

  onAppsDetailsClick() {
    history.push('/billing/apps_details');
  }

  getCoupons() {
    return SashiDo.getUserBillingCoupons();
  }

  addCard() {
    history.push('/billing/add_card');
  }

  edit() {
    history.push('/billing/edit_card');
  }

  handleDownloadInvoice(invoice_id, date) {
    SashiDo.activityTrack({
      type: 'download_invoice',
      data: {
        message: `Invoice from ${date} was downloaded`,
      },
    });

    SashiDo.getUserBillingInvoiceUrl({ invoice_id }).then(({ url }) => {
      location.href = url;
    });
  }

  render() {
    const { products } = this.state;
    const classes = [settingsStyles.settings_page, settingsStyles.default];

    if (this.state.loading) {
      return (
        <div className={classes.join(' ')}>
          <Toolbar section={this.section} subsection={this.subsection} />
          <PreLoader loading={this.state.loading} />
        </div>
      );
    }

    const billingInfo = (
      <Fieldset
        legend="Payment Method"
        description={`Next payment due: ${moment.unix(this.props.currentCustomer.subscription.next_billing_at).utc().format('DD MMM YYYY')}`}>
        <div className={settingsStyles.settingsBox}>
          <div className={[styles.box, styles.table, styles.billingInfo].join(' ')}>

            <div className={styles.tableRow}>
              <div className={styles.col1}>Billing Info</div>
            </div>

            <div className={[styles.box, styles.pa].join(' ')}>
              <div className={[styles.columns].join(' ')}>
                <div className={styles.left}>
                  <div className={styles.row}>
                    <label>Full Name :</label>
                    <span>{this.models.name.value}</span>
                  </div>
                  <div className={styles.row}>
                    <label>Address :</label>
                    <span>{this.models.address.value}</span>
                  </div>

                  <div className={styles.row}>
                    <label>Country :</label>
                    <span>{Object.keys(isoCountries).filter(country => isoCountries[country] == this.models.country.value)}</span>
                  </div>

                  <div className={styles.row}>
                    <label>State :</label>
                    <span>{this.models.state.value}</span>
                  </div>
                  <div className={styles.row}>
                    <label>Company :</label>
                    <span>{this.models.company_name.value}</span>
                  </div>
                </div>

                <div className={styles.right}>
                  <div className={styles.row}>
                    <label>E-mail :</label>
                    <span>{this.models.email.value}</span>
                  </div>
                  <div className={styles.row}>
                    <label>Phone :</label>
                    <span>{this.models.phone.value}</span>
                  </div>
                  <div className={styles.row}>
                    <label>City :</label>
                    <span>{this.models.city.value}</span>
                  </div>
                  <div className={styles.row}>
                    <label>ZIP :</label>
                    <span>{this.models.zip.value}</span>
                  </div>
                  <div className={styles.row}>
                    <label>VAT ID :</label>
                    <span>{this.models.vat_id.value}</span>
                  </div>
                </div>
              </div>
            </div>

            {this.props.currentCustomer.card
              ? <div>
                <div className={[styles.box, styles.pa].join(' ')}>
                  <div className={[styles.columns].join(' ')}>
                    <div className={styles.left}>
                      <div className={styles.row}>
                        <label><Icon name={`icon-${this.props.currentCustomer.card.card_type}`} width={30} height={30} colored /></label>
                        <span className={styles.num}>{this.props.currentCustomer.card.masked_number}</span>
                      </div>
                    </div>

                    <div className={styles.right}>
                      <div className={styles.row}>
                        <label>Expires :</label>
                        <span>{`${this.props.currentCustomer.card.expiry_month}/${this.props.currentCustomer.card.expiry_year}`}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              : null
            }

            <div className={styles.hr} style={{ marginBottom: 20 }} />

            <div className={styles.box}>
              <Button
                color="blue"
                value="Update Payment Method or Billing Info"
                block
                onClick={this.edit.bind(this)} />
            </div>

            <div className={styles.box}>
              <div className={styles.payments}>
                <span>Our payments are managed and secured by:</span>
                <img src="/assets/images/braintree-logo.svg" width="120" alt="Braintree" />
              </div>
            </div>

          </div>
        </div>
      </Fieldset>
    );


    const desc = (
      this.props.currentCustomer.has_payment_method && this.props.currentCustomer.card.status == 'valid'
        ? 'If you have a Promo Code, please enter it below to receive your credit.'
        : 'Before you can redeem your coupon,<br /> you must have a primary payment method for your account.'
    );

    const applyCoupon = (
      <Fieldset
        legend="Coupons"
        descriptionWithHTML={desc}>
        {
          this.props.currentCustomer.has_payment_method && this.props.currentCustomer.card.status == 'valid'
            ?
            <div className={settingsStyles.settingsBox}>
              <Field
                label={<Label
                  text="Enter Promo Code" />
                }
                input={<InlineSubmitInput
                  validate={() => { return true; }}
                  placeholder=""
                  onSubmit={(coupon_id) => {
                    this.setState({ note: null });

                    if (coupon_id === couponXmass && !this.props.currentUser.backups_enabled) {
                      this.setState({ note: { type: 'error', message: 'Please Activate Automatic Backups to apply this coupon.' } });
                      return Promise.resolve();
                    }

                    return SashiDo.setUserBillingCoupon({ coupon_id }).then(() => {
                      this.getCoupons().then(({ coupons }) => {
                        this.setState({
                          coupons,
                          note: { type: 'success', message: `Successfully activated coupon ${coupon_id}` },
                        });
                      });
                    }).catch((error) => {
                      this.setState({ note: { type: 'error', message: error.response.data.error } });
                    });
                  }}
                  submitButtonText="Apply" />
                } />


              {
                Object.keys(this.state.coupons).length > 0
                  ?
                  <div className={[styles.box, styles.table, styles.couponsHistory].join(' ')}>
                    <div>
                      <div className={styles.tableRow}>
                        <div className={styles.col1}>Active Coupon</div>
                        <div className={styles.col2}>Description</div>
                      </div>
                      {
                        Object.keys(this.state.coupons).map((i) => {
                          const row = (
                            <div className={styles.tableRow} key={i}>
                              <div className={styles.col1}>
                                {i}
                              </div>
                              <div className={styles.col2}>
                                {
                                  i === couponXmass
                                    ?
                                    '$15 credits X-Mas bonus for engines'
                                    :
                                    this.state.coupons[i].type == 'percentage'
                                      ?
                                      `${this.state.coupons[i].percentage}% Discount`
                                      :
                                      `${this.state.coupons[i].amount / 100}$ Discount`
                                }
                              </div>
                            </div>
                          );

                          return row;
                        })
                      }
                    </div>
                  </div>
                  : null
              }

            </div>

            :
            <div className={settingsStyles.settingsBox}>
              <div className={styles.box}>
                <Button
                  color="blue"
                  value="Add Payment Method"
                  block
                  onClick={this.addCard.bind(this)} />
              </div>
            </div>
        }
      </Fieldset>
    );

    // TODO: @pivanov
    // console.log('@this.state.appsStats', this.state.appsStats);

    const appsPremiumServices =
      (<Fieldset
        legend="Overview"
        description="Prices exclude VAT">
        <div className={settingsStyles.settingsBox}>
          <div className={[styles.box, styles.table, styles.totalApps].join(' ')}>
            <div className={styles.tableRow}>
              <div className={styles.col1}>Total Apps</div>
              <div className={styles.col2}>Total Price</div>
              <div className={styles.col3}>More</div>
            </div>

            {
              this.state.appsStats.total_price &&
              <div className={[styles.tableRow, styles.last].join(' ')}>
                <div className={styles.col1}>
                  {Object.keys(this.state.appsStats.stats).filter(i => Object.keys(this.state.appsStats.stats[i]).length).length}
                </div>
                <div className={styles.col2}>
                  <div className={styles.totalPrice}>
                    <div className={styles.usagePrice}>
                      {formatter.price(this.state.appsStats.total_price)}
                    </div>
                  </div>
                </div>
                <div className={styles.col3}>
                  <a
                    className={[stylesButton.tableButton, stylesButton.green].join(' ')}
                    href="javascript:;"
                    onClick={this.onAppsDetailsClick.bind(this)}>
                    Details
                  </a>
                </div>
              </div>
            }
          </div>
        </div>
      </Fieldset>);

    // console.log('this.state.appsStats', this.state.appsStats)

    const appsInfo = this.state.appsStats.length > 0 &&
      (<Fieldset
        legend="Applications Overview"
        description={'See \'Details\' for Each App. Prices exclude VAT'}>
        <div className={settingsStyles.settingsBox}>
          <div className={[styles.box, styles.table, styles.totalApps].join(' ')}>
            <div className={styles.tableRow}>
              <div className={styles.col1}>Total Apps</div>
              <div className={styles.col2}>Total Price</div>
              <div className={styles.col3}>More</div>
            </div>

            {
              this.state.appsStats.total_price &&
              <div className={[styles.tableRow, styles.last].join(' ')}>
                <div className={styles.col1}>
                  {Object.keys(this.state.appsStats.stats).filter(i => Object.keys(this.state.appsStats.stats[i]).length).length}
                </div>
                <div className={styles.col2}>
                  <div className={styles.totalPrice}>
                    <div className={styles.usagePrice}>
                      {formatter.price(this.state.appsStats.total_price)}
                    </div>
                  </div>
                </div>
                <div className={styles.col3}>
                  <span
                    className={[stylesButton.tableButton, stylesButton.green].join(' ')}
                    onClick={this.onAppsDetailsClick.bind(this)}>
                    Details
                  </span>
                </div>
              </div>
            }
          </div>
        </div>
      </Fieldset>);


    const havePaymentHistory = this.props.currentCustomer.history.length > 0;


    const paymentHistory = (
      <Fieldset
        legend="Payment History"
        description="">
        <div className={settingsStyles.settingsBox}>
          <div className={[styles.box, havePaymentHistory ? styles.table : null, styles.paymentHistory].join(' ')}>
            {
              havePaymentHistory
                ?
                <div>
                  <div className={styles.tableRow}>
                    <div className={styles.col1}>Status</div>
                    <div className={styles.col2}>Date</div>
                    <div className={styles.col3}>Amount</div>
                    {/*
                        <div className={styles.col4}>Payment method</div>
                        */}
                    <div className={styles.col5}>Invoice</div>
                  </div>

                  {
                    this.props.currentCustomer.history.map((history) => {
                      const icon = {};
                      // if (history.transaction.status == 'success') {
                      if (history.invoice.status == 'paid') {
                        icon.name = 'icon-check';
                        icon.color = '#1bb933';
                        icon.size = 14;
                      } else {
                        icon.name = 'icon-close';
                        icon.color = '#f62943';
                        icon.size = 10;
                      }

                      // let amount = history.transaction.amount / 100;
                      const amount = history.invoice.total / 100;

                      const row = (
                        // <div className={styles.tableRow} key={history.transaction.id}>
                        <div className={styles.tableRow} key={history.invoice.id}>
                          <div className={styles.col1}>
                            <Icon name={icon.name} width={icon.size} height={icon.size} colored fill={icon.color} />
                          </div>
                          <div className={styles.col2}>
                            {/* timeStampToUTC(history.transaction.date, true) */}
                            {timeStampToUTC(history.invoice.date, true)}
                          </div>
                          <div className={styles.col3}>
                            {amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                          </div>
                          {/* // TODO Probably save invoice_id and the card for the transaction in our db
                              <div className={[styles.col4, styles.paymentMethod].join(' ')}>
                                <Icon name={`icon-${this.props.currentCustomer.card.card_type}`} width={30} height={30} colored={true} />
                                  <span className={styles.num}>{history.transaction.masked_card_number}</span>
                              </div>
                              */}
                          <div className={styles.col5}>
                            {
                              // history.transaction.status == 'success' // in_progress, voided, failure, timeout, needs_attention
                              history.invoice.status == 'paid' // in_progress, voided, failure, timeout, needs_attention
                                ?
                                // <span onClick={ () => this.handleDownloadInvoice(history.transaction.linked_invoices[0].invoice_id) }>
                                <span onClick={() => this.handleDownloadInvoice(history.invoice.id, timeStampToUTC(history.invoice.date, true))}>
                                  <Icon name="icon-download" width={16} height={16} colored fill="#0092ff" onClick={() => this.handleDownloadInvoice(history.invoice.id/* history.transaction.linked_invoices[0].invoice_id */)} />
                                </span>
                                :
                                // history.transaction.linked_invoices[0] && history.transaction.linked_invoices[0].invoice_status == 'paid'
                                // ?
                                //   'Paid'
                                // :
                                //   history.transaction.linked_invoices[0]
                                //   ?

                                (
                                  amount > 0
                                    ? <a
                                      style={{
                                        width: 'auto',
                                        margin: '10px 0',
                                        height: 'auto',
                                      }}
                                      className={[stylesButton.tableButton, stylesButton.green].join(' ')}
                                      href="javascript:;"
                                      onClick={() => {
                                        if (this.props.currentUser.use_payment_v2) {
                                          return SashiDo.requestUserBillingPaymentV2({ invoice_id: history.invoice.id }).then(({ success, error }) => {
                                            if (error) {
                                              this.setState({ note: { type: 'error', message: error } });
                                            }

                                            if (success) {
                                              this.setState({ note: { type: 'success', message: 'Invoice payment succeeded' } });
                                            }
                                          });
                                        }

                                        SashiDo.requestUserBillingPayment({ invoice_id: history.invoice.id }).then(({ success, error }) => {
                                          if (error) {
                                            this.setState({ note: { type: 'error', message: error } });
                                          }

                                          if (success) {
                                            this.setState({ note: { type: 'success', message: 'Invoice payment succeeded' } });
                                          }
                                        });
                                      }}>
                                      Pay Now
                                    </a>
                                    : null
                                )
                              // :
                              //   'Failed'

                            }
                          </div>
                        </div>
                      );

                      return row;
                    })
                  }
                </div>
                :
                <p className={settingsStyles.taC}>You don't have payment history yet</p>
            }
          </div>
        </div>
      </Fieldset>
    );

    const wallet = (
      <Fieldset
        legend="Virtual Wallet"
        description="The Credits from your wallet will automatically be applied to your bills.">
        <div className={settingsStyles.settingsBox}>
          <div className={[styles.box, styles.table, styles.wallet].join(' ')}>
            <div className={[styles.tableRow, styles.last].join(' ')}>
              <div className={styles.col1}>
                <Icon name="icon-coins" width={30} height={30} />
              </div>
              <div className={styles.col2}>
                <div className={styles.totalPrice}>
                  <div className={styles.usagePrice}>
                    {formatter.price(this.props.currentCustomer.info.promotional_credits)}
                  </div>
                </div>
              </div>
              <div className={[styles.col3, styles.earnMoney].join(' ')}>
                <a
                  className={[stylesButton.tableButton, stylesButton.green].join(' ')}
                  href="javascript:;"
                  onClick={() => { history.push('/referrals'); }}>
                  Earn Money
                </a>
              </div>
            </div>
          </div>
        </div>
      </Fieldset>
    );

    return (
      <div className={classes.join(' ')}>
        <Toolbar section={this.section} subsection={this.subsection} />
        <PreLoader loading={this.state.loading}>
          <div className={settingsStyles.holder}>
            {wallet}
            {products && appsPremiumServices}
            {applyCoupon}
            {appsInfo}
            {billingInfo}
            {paymentHistory}
          </div>
        </PreLoader>
        <Notification note={this.state.note} fullscreen={false} close />
      </div>
    );
  }
}

function v_require(value) {
  if (value !== '') {
    return true;
  }

  return false;
}
